import { Person } from '@/api/entities/people/types'
import { Subtask } from '@/api/pathways/subtasks/types'
// nosemgrep: no-legacy-api-store
import apiStore from '@/legacy/store/modules/apiBuilder'
import { IdMap } from '@/legacy/types/api/store'
import { GenericListResponse } from '@/libs/api/types'
import { idMapTransform } from '@/libs/format/objects'

export const usePointerSubtaskApi = apiStore<Subtask>(
  'pointerSubtaskApi',
  '/api/subtasks',
  {
    transformData: (d: GenericListResponse<Subtask>) => d,
  }
)

export const usePointerSubtaskPersonApi = apiStore<Person, IdMap<Person>>(
  'pointerSubtaskPersonApi',
  '/api/people',
  {
    transformData: (d: { data: Person[] }) =>
      idMapTransform({}, 'data', 'entityId', d.data),
  }
)
